export function SideNav() {
    const toggleLabel = document.querySelector('.side-nav__label');
    const toggleCheckbox = document.querySelector('.side-nav__toggle');

    // Keyboard support
    toggleLabel.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            toggleCheckbox.checked = !toggleCheckbox.checked;
            toggleLabel.setAttribute('aria-expanded', toggleCheckbox.checked);
        }
    });

    // Accessibility
    toggleCheckbox.addEventListener('change', function() {
        toggleLabel.setAttribute('aria-expanded', toggleCheckbox.checked);
    });
}